import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typo, Icon } from '.';

const AccordionsContext = React.createContext({
    register: (id) => null
});
export const Accordions = ({ children }) => {
    const [opened, open] = useState(null);
    const [accordions, setAccordions] = useState([]);
    const close = () => open(null);
    const isOpened = (id) => id === opened;
    const register = (id) => {
        if (!accordions.indexOf(id)) {
            setAccordions([id, ...accordions]);
        }
        return {
            isOpened: () => isOpened(id),
            open: () => open(id),
            close
        };
    };
    return (
        <AccordionsContext.Provider
            value={register}
        >
            {children}
        </AccordionsContext.Provider>
    );
};
export const Accordion = ({ id, title, children }) => {
    const register = useContext(AccordionsContext);
    const { isOpened, open, close } = register(id);
    const opened = isOpened();
    const toggle = () => (opened ? close() : open());
    return (
        <div className={cx('accordion', { 'accordion--opened': opened })}>
            <div className="accordion__header" onClick={toggle}>
                <Typo.Menu>{title}</Typo.Menu>
                <Icon name="anchor" className="accordion__anchor" />
            </div>
            <div className="accordion__content">
                <div className="accordion__inner">
                    {children}
                </div>
            </div>
        </div>
    );
};
Accordion.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.string.isRequired
};
